<template>
  <section class="ui-card" :class="tone">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'UiCard',
  props: {
    tone: {
      type: String,
      default: ''
    }
  }
}
</script>
